module.exports = __webpack_public_path__ + "img/install-info.95704f08.svg";